import React from "react";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { Link } from "react-router-dom";

export default function Success() {
  return (
    <>
      <Typography variant="h2" align="center" sx={{ py: 4 }}>
        Thank you!
      </Typography>
      <Typography component="p" align="center">
        You will get an email with further instructions. <br />
        আমরা খুব শিঘ্রই আপনার সাথে যোগাযোগ করবো। কোনো তথ্য জানার যোগাযোগ করুন:
        +880 1960602760
      </Typography>
      <Link to="/dashboard">
        <Button
          variant="contained"
          style={{ backgroundColor: "red" }}
          sx={{ mt: 2, mx: "auto", display: "block" }}
        >
          Go to Dashboard
        </Button>
      </Link>
    </>
  );
}
